import { Link } from 'react-router-dom';
import { LEGAL_VERSIONS } from '@makhe/shared';

export function LegalFooterNav() {
  return (
    <nav className="flex flex-wrap gap-x-6 gap-y-2 text-[11px] uppercase tracking-widest text-makhe-muted">
      <Link to="/legal/terms" className="hover:text-makhe-ink transition-colors">Terms</Link>
      <Link to="/legal/privacy" className="hover:text-makhe-ink transition-colors">Privacy</Link>
      <Link to="/legal/refunds" className="hover:text-makhe-ink transition-colors">Refunds</Link>
      <Link to="/legal/seller-agreement" className="hover:text-makhe-ink transition-colors">Sellers</Link>
      <Link to="/legal/community-guidelines" className="hover:text-makhe-ink transition-colors">Community</Link>
      <Link to="/legal/cookie-policy" className="hover:text-makhe-ink transition-colors">Cookies</Link>
      <span className="text-makhe-muted/50">v{LEGAL_VERSIONS.terms}</span>
    </nav>
  );
}
